import { useEffect, useState } from 'react'
import { Button } from '../../components/ui/Button.tsx'
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card.tsx'
import LoadingSpinner from '../../components/ui/LoadingSpinner.tsx'
import { apiGet, apiPostForm } from '../../lib/api.ts'

export default function ProfilePage() {
  const [loading, setLoading] = useState(true)
  const [notice, setNotice] = useState('')
  const [form, setForm] = useState({
    practice_name: '',
    contact_name: '',
    phone: '',
    website_url: '',
    city: '',
    description: '',
  })

  const load = async () => {
    try {
      const data = await apiGet<{ practice: typeof form }>('/practice/profile.php?format=json')
      setForm(data.practice)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    void load()
  }, [])

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    try {
      const data = await apiPostForm<{ message: string }>('/practice/profile.php?format=json', form)
      setNotice(data.message)
      await load()
    } catch (err) {
      setNotice(err instanceof Error ? err.message : 'Unable to save profile.')
    }
  }

  if (loading) {
    return <LoadingSpinner />
  }

  return (
    <div className="p-4 space-y-4">
      <div>
        <h1 className="text-2xl font-bold text-text-900">Practice Profile</h1>
        <p className="mt-1 text-sm text-text-600">Keep your practice contact and location details current.</p>
      </div>

      {notice && <div className="rounded-lg bg-brand-50 p-3 text-sm text-brand-800">{notice}</div>}

      <Card>
        <CardHeader>
          <CardTitle>Practice details</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-3">
            <input className="w-full rounded-md border border-surface-600 px-3 py-3" placeholder="Practice name" value={form.practice_name} onChange={(event) => setForm((current) => ({ ...current, practice_name: event.target.value }))} required />
            <input className="w-full rounded-md border border-surface-600 px-3 py-3" placeholder="Contact name" value={form.contact_name} onChange={(event) => setForm((current) => ({ ...current, contact_name: event.target.value }))} required />
            <input className="w-full rounded-md border border-surface-600 px-3 py-3" placeholder="Phone" value={form.phone} onChange={(event) => setForm((current) => ({ ...current, phone: event.target.value }))} />
            <input className="w-full rounded-md border border-surface-600 px-3 py-3" placeholder="Website" value={form.website_url} onChange={(event) => setForm((current) => ({ ...current, website_url: event.target.value }))} />
            <input className="w-full rounded-md border border-surface-600 px-3 py-3" placeholder="City" value={form.city} onChange={(event) => setForm((current) => ({ ...current, city: event.target.value }))} />
            <textarea className="w-full rounded-md border border-surface-600 px-3 py-3" rows={4} placeholder="Description" value={form.description} onChange={(event) => setForm((current) => ({ ...current, description: event.target.value }))} />
            <Button type="submit" className="w-full bg-brand-600 hover:bg-brand-700">
              Save profile
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
